import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'

export interface AuthenticationState {
  token: string
}

const initialState: AuthenticationState = {
  token: ''
}

// https://redux-toolkit.js.org/usage/usage-with-typescript#createslice

export const authenticationSlice = createSlice({
  name: 'authentication',
  initialState,
  reducers: {
    addToken: (state, action: PayloadAction<string>) => {
      state.token = action.payload
    }
  }
})

// Action creators are generated for each case reducer function
export const { addToken } = authenticationSlice.actions

export default authenticationSlice.reducer
